const html = document.documentElement
const languageCountryPair = html.getAttribute('lang')
const langCode = languageCountryPair.split('-')[0]

export { langCode }
